import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import Layout from '../components/Layout';

export default function PlaceholderPage({ title }) {
  return (
    <Layout>
      <Typography variant="h5" sx={{ fontWeight: 900, mb: 2 }}>
        {title}
      </Typography>
      <Paper sx={{ p: 3, borderRadius: 4 }}>
        <Box sx={{ color: 'text.secondary' }}>
          This section is not implemented yet (Coming soon).
        </Box>
      </Paper>
    </Layout>
  );
}


